"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpNavItem = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
require("./styles.scss");
const nav_item_html_1 = __importDefault(require("./nav-item.html"));
const core_1 = require("@integro/core");
let ItpNavItem = class ItpNavItem extends vue_property_decorator_1.Vue {
    url;
    spinning;
    text;
    icon;
    to;
    href;
    disabled;
    target;
    dropdownItem;
    useAuth;
    forceDownload;
    downloadFileName;
    showSpinner;
    spinnerType;
    get componentName() {
        return this.dropdownItem ? 'b-dropdown-item' : 'b-nav-item';
    }
    data() {
        return {
            url: this.href ? core_1.downloads.normalizeLink(this.href) : '',
            spinning: false
        };
    }
    get isDisabled() {
        return this.disabled;
    }
    onClick(ev) {
        if (this.forceDownload) {
            return this.onDownloadClick(ev);
        }
        if (this.useAuth) {
            ev.preventDefault();
            if (this.showSpinner) {
                this.spinning = true;
            }
            Promise.resolve(core_1.downloads.getFileBLOB(this.url, this.downloadFileName))
                .then(p => p && core_1.downloads.showFileInNewTab(p.file, p.fileName))
                .finally(() => (this.spinning = false));
            return;
        }
        if (!this.href || this.href == '#') {
            ev.preventDefault();
            this.$emit('click', ev);
        }
    }
    onDownloadClick(ev) {
        if (this.useAuth) {
            ev.preventDefault();
            Promise.resolve(core_1.downloads.getFileBLOB(this.url, this.downloadFileName)).then(p => p && core_1.downloads.downloadBlob(p.file, p.fileName));
        }
    }
};
exports.ItpNavItem = ItpNavItem;
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpNavItem.prototype, "text", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpNavItem.prototype, "icon", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Object)
], ItpNavItem.prototype, "to", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpNavItem.prototype, "href", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpNavItem.prototype, "disabled", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: '_self' }),
    __metadata("design:type", String)
], ItpNavItem.prototype, "target", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpNavItem.prototype, "dropdownItem", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpNavItem.prototype, "useAuth", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpNavItem.prototype, "forceDownload", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", String)
], ItpNavItem.prototype, "downloadFileName", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpNavItem.prototype, "showSpinner", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'grow' }),
    __metadata("design:type", String)
], ItpNavItem.prototype, "spinnerType", void 0);
exports.ItpNavItem = ItpNavItem = __decorate([
    (0, vue_property_decorator_1.Component)({ template: nav_item_html_1.default })
], ItpNavItem);
//# sourceMappingURL=nav-item.js.map